/**
 * Barcode Lookup Hook
 * ===================
 * React Query hook for barcode lookup operations.
 */

import { useMutation } from '@tanstack/react-query'
import { barcodeApi } from '@/services/api'

/**
 * Hook to look up product information by barcode.
 */
export function useBarcodeLookup() {
  return useMutation({
    mutationFn: (barcode: string) => barcodeApi.lookup(barcode),
  })
}
